// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HEADER SKELETON */
.header-skeleton {
  align-items: center;
  background-color: var(--intelibly-branding-secondary-50);
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  padding: 24px 20px;
  width: 100%;
}

.header-skeleton .appointment-details-skeleton {
  width: 75%;
}

/* DATE SELECTION SKELETON */
.date-selection-skeleton {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 100%;
}

.date-selection-skeleton .subheader-skeleton {
  width: 60%;
}

.date-selection-skeleton .calendar-skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.date-selection-skeleton .calendar-header-skeleton {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.date-selection-skeleton .month-year-skeleton {
  flex: 0.5;
}

.date-selection-skeleton .arrow-button-container {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.date-selection-skeleton .date-picker-skeleton {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.date-selection-skeleton .days-header-skeleton {
  height: 40px;
}

/* TIME SELECTION SKELETON */
.time-selection-skeleton {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  width: 100%;
}

.time-selection-skeleton .subheader-skeleton {
  width: 60%;
}

.time-selection-skeleton .time-picker-skeleton {
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 16px 20px;
  width: 100%;
  display: flex;
}

.time-selection-skeleton .time-slot-skeleton {
  width: 45%;
}
`, "",{"version":3,"sources":["webpack://./../shared-components/lib/Skeleton/style.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* HEADER SKELETON */\n.header-skeleton {\n  align-items: center;\n  background-color: var(--intelibly-branding-secondary-50);\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  justify-content: center;\n  padding: 24px 20px;\n  width: 100%;\n}\n\n.header-skeleton .appointment-details-skeleton {\n  width: 75%;\n}\n\n/* DATE SELECTION SKELETON */\n.date-selection-skeleton {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  width: 100%;\n}\n\n.date-selection-skeleton .subheader-skeleton {\n  width: 60%;\n}\n\n.date-selection-skeleton .calendar-skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.date-selection-skeleton .calendar-header-skeleton {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.date-selection-skeleton .month-year-skeleton {\n  flex: 0.5;\n}\n\n.date-selection-skeleton .arrow-button-container {\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n}\n\n.date-selection-skeleton .date-picker-skeleton {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.date-selection-skeleton .days-header-skeleton {\n  height: 40px;\n}\n\n/* TIME SELECTION SKELETON */\n.time-selection-skeleton {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  width: 100%;\n}\n\n.time-selection-skeleton .subheader-skeleton {\n  width: 60%;\n}\n\n.time-selection-skeleton .time-picker-skeleton {\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px 20px;\n  width: 100%;\n  display: flex;\n}\n\n.time-selection-skeleton .time-slot-skeleton {\n  width: 45%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
